import {
    AdministrationHomeComponent as AdminHome,
} from "@administration/administration-home/administration-home.component";
import { Routes } from "@angular/router";
import { LoggedGuard } from "@lib/auth/guards/logged.guard";
import BackendNotAvailableComponent from "@pages/error-pages/backend-not-available/backend-not-available.component";
import NotAuthorizedAppAccessComponent
    from "@pages/error-pages/not-authorized-app-access/not-authorized-app-access.component";
import { WorkspaceHomeComponent as WorkspaceHome } from "@pages/workspace/workspace-home/workspace-home.component";
import { AdministrationUbiHomeComponent } from "@administration-ubi/administration-home/administration-home.component";
import { RoleGuard } from "@lib/core/modules/roles/guards/role.guard";

export const APP_ROUTES: Routes = [
    {
        path: "workspace",
        component: WorkspaceHome,
        loadChildren: () =>
            import("@pages/workspace/workspace.routes"),
        canActivate: [LoggedGuard],
    },
    {
        path: "administration-ubi",
        component: AdministrationUbiHomeComponent,
        loadChildren: () =>
            import("@pages/administration-ubi/administration.routes"),
        canActivate: [RoleGuard],
        data: { roles: ["Administrator"] },

    },
    {
        path: "administration",
        component: AdminHome,
        loadChildren: () =>
            import("@pages/administration/administration.routes"),
        canActivate: [LoggedGuard],
    },
    {
        path: "not-authorized-app-access",
        component: NotAuthorizedAppAccessComponent,
        canActivate: [LoggedGuard],
    },
    {
        path: "backend-not-available",
        component: BackendNotAvailableComponent,
        canActivate: [LoggedGuard],
    },
    {
        path: "**",
        redirectTo: "workspace",
    },
];
